import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LazyLoadComponent } from '@awread/global/packages';
import { FooterTemplate } from '../../atomics/templates/footer/footer.template.js';
import { SharedLayout } from '../shared/shared.layout.js';
import { FrictionlessLoginDialog } from '@awread/global/dialogs';
import { NavbarMbOrgan } from '../../atomics/organs/navbar-mb/navbar-mb.organ.js';
import { BottomNavTemplate } from '../../atomics/templates/bottom-nav/bottom-nav.template.js';

@Component({
  standalone: true,
  selector: 'awread-shared-desktop',
  imports: [CommonModule, RouterModule, FooterTemplate, LazyLoadComponent, NavbarMbOrgan, BottomNavTemplate, FrictionlessLoginDialog],
  templateUrl: './shared-desktop.layout.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedDesktopLayout extends SharedLayout { }
